// extracted by mini-css-extract-plugin
export default {"info":"info_info__-73++","flx":"info_flx__MrFX+","div_footer":"info_div_footer__4BdYy"};